import { motion } from 'framer-motion';

/* Interruptor de diagnóstico temporal (2026-07-21): con ?noanim=1 en la URL se
   desactivan las animaciones infinitas/whileInView para descartar si son la
   causa de un crash de react-dom detectado solo en un Chrome/Android concreto,
   sin tener acceso a depuración remota de ese dispositivo. Quitar cuando se
   confirme o descarte la causa. */
function computeNoAnim() {
  if (typeof window === 'undefined') return false;
  if (new URLSearchParams(window.location.search).has('noanim')) {
    sessionStorage.setItem('kanel-noanim', '1');
    return true;
  }
  return sessionStorage.getItem('kanel-noanim') === '1';
}
export const NOANIM = computeNoAnim();

/* ============================================================
   Kanel Bakery — Doodles line-art "hechos a mano"
   Trazo berenjena, fill:none, esquinas redondeadas.
   <Doodle name="cupcake" draw /> dibuja el trazo al entrar en viewport.
   ============================================================ */

const drawV = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: (i = 0) => ({
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: { delay: 0.1 + i * 0.12, duration: 1, ease: 'easeInOut' },
      opacity: { delay: 0.1 + i * 0.12, duration: 0.25 },
    },
  }),
};

/* Primitiva: path/line/circle estática o animada (draw) */
function P({ draw, i = 0, as = 'path', ...props }) {
  if (!draw) {
    const El = as;
    return <El {...props} />;
  }
  const M = motion[as];
  return <M variants={drawV} custom={i} {...props} />;
}

/* Definición de cada doodle. Cada función recibe {draw} y devuelve los trazos. */
const shapes = {
  cupcake: (d) => (
    <>
      <P {...d} i={0} d="M16 30 Q12 22 20 21 Q22 12 32 14 Q43 12 45 22 Q53 23 48 30" />
      <P {...d} i={1} d="M15 30 H49 L44 52 Q43 56 39 56 H25 Q21 56 20 52 Z" />
      <P {...d} i={2} d="M27 33 28 53" />
      <P {...d} i={3} d="M33 33 33 54" />
      <P {...d} i={4} d="M39 33 38 53" />
      <P {...d} i={5} as="circle" cx="32" cy="11" r="3" />
      <P {...d} i={6} d="M32 9 Q34 4 38 4" />
    </>
  ),
  heart: (d) => (
    <P {...d} i={0} d="M32 50 C12 34 16 16 32 24 C48 16 52 34 32 50 Z" />
  ),
  sparkle: (d) => (
    <>
      <P {...d} i={0} d="M32 11 C33 25 39 31 53 32 C39 33 33 39 32 53 C31 39 25 33 11 32 C25 31 31 25 32 11 Z" />
      <P {...d} i={1} d="M51 12 C51 17 52 18 56 18 C52 18 51 20 51 24 C51 20 49 18 46 18 C49 18 51 17 51 12 Z" />
    </>
  ),
  cherry: (d) => (
    <>
      <P {...d} i={0} as="circle" cx="22" cy="46" r="8" />
      <P {...d} i={1} as="circle" cx="42" cy="48" r="8" />
      <P {...d} i={2} d="M22 38 C24 24 34 18 46 16" />
      <P {...d} i={3} d="M42 40 C42 28 44 22 46 16" />
      <P {...d} i={4} d="M46 16 q9 -5 13 1 q-8 3 -13 -1 Z" />
    </>
  ),
  sprinkles: (d) => (
    <>
      <P {...d} i={0} d="M16 22 22 17" />
      <P {...d} i={1} d="M30 15 35 23" />
      <P {...d} i={2} d="M44 17 49 24" />
      <P {...d} i={3} d="M20 38 27 33" />
      <P {...d} i={4} d="M40 37 46 42" />
      <P {...d} i={5} d="M30 44 34 52" />
    </>
  ),
  drip: (d) => (
    <P {...d} i={0} d="M10 18 H54 V30 Q50 42 46 31 Q42 21 38 33 Q35 44 31 32 Q27 21 23 34 Q19 45 15 32 Q12 26 10 27 Z" />
  ),
  cookie: (d) => (
    <>
      <P {...d} i={0} d="M32 14 C44 13 52 23 50 34 C49 46 38 53 27 49 C16 46 12 35 16 25 C19 17 25 15 32 14 Z" />
      <P {...d} i={1} as="circle" cx="27" cy="27" r="1.6" />
      <P {...d} i={2} as="circle" cx="39" cy="26" r="1.6" />
      <P {...d} i={3} as="circle" cx="33" cy="38" r="1.6" />
      <P {...d} i={4} as="circle" cx="41" cy="39" r="1.6" />
      <P {...d} i={5} as="circle" cx="24" cy="37" r="1.6" />
    </>
  ),
  candle: (d) => (
    <>
      <P {...d} i={0} d="M26 30 H38 V54 Q38 56 36 56 H28 Q26 56 26 54 Z" />
      <P {...d} i={1} d="M31 33 36 33" />
      <P {...d} i={2} d="M32 30 32 25" />
      <P {...d} i={3} d="M32 25 C28 20 32 13 32 13 C32 13 36 20 32 25 Z" />
      <P {...d} i={4} d="M22 18 18 15" />
      <P {...d} i={5} d="M42 18 46 15" />
    </>
  ),
  cloud: (d) => (
    <P {...d} i={0} d="M18 42 C10 42 10 32 18 32 C18 24 30 22 32 30 C36 22 50 24 47 34 C55 34 55 44 47 44 Z" />
  ),
  whisk: (d) => (
    <>
      {/* mango + anilla */}
      <P {...d} i={0} d="M32 40 L32 55" />
      <P {...d} i={1} as="circle" cx="32" cy="57.5" r="2.4" />
      {/* collar */}
      <P {...d} i={2} d="M28 40 L36 40" />
      {/* globo de alambres */}
      <P {...d} i={3} d="M32 40 C18 36 18 15 32 8" />
      <P {...d} i={4} d="M32 40 C46 36 46 15 32 8" />
      <P {...d} i={5} d="M32 40 C27 30 27 16 31 9" />
      <P {...d} i={6} d="M32 40 C37 30 37 16 33 9" />
      {/* aros transversales */}
      <P {...d} i={7} d="M21 18 Q32 25 43 18" />
      <P {...d} i={8} d="M20 27 Q32 34 44 27" />
      {/* remate */}
      <P {...d} i={9} as="circle" cx="32" cy="7" r="1.8" />
    </>
  ),
  swirl: (d) => (
    <P {...d} i={0} d="M16 40 C16 28 44 28 44 40 C44 49 28 49 28 40 C28 34 38 34 38 40" />
  ),
};

export function Doodle({
  name = 'cupcake',
  size = 56,
  color = 'var(--plum)',
  stroke = 2.4,
  draw = false,
  title,
  className,
  style,
}) {
  draw = draw && !NOANIM;
  const Svg = draw ? motion.svg : 'svg';
  const svgProps = {
    width: size,
    height: size,
    viewBox: '0 0 64 64',
    className,
    style,
    role: title ? 'img' : 'presentation',
    'aria-hidden': title ? undefined : true,
    ...(draw
      ? { initial: 'hidden', whileInView: 'visible', viewport: { once: true, amount: 0.4 } }
      : {}),
  };
  const render = shapes[name] || shapes.cupcake;
  return (
    <Svg {...svgProps}>
      {title && <title>{title}</title>}
      <g fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round">
        {render({ draw })}
      </g>
    </Svg>
  );
}

/* ---- Wrappers de movimiento ---- */

/* Flotación suave e infinita */
export function Float({ children, amp = 8, dur = 4, delay = 0, rotate = 0, className, style }) {
  if (NOANIM) return <div className={className} style={style}>{children}</div>;
  return (
    <motion.div
      className={className}
      style={style}
      animate={{ y: [0, -amp, 0], rotate: rotate ? [0, rotate, 0] : 0 }}
      transition={{ duration: dur, repeat: Infinity, ease: 'easeInOut', delay }}
    >
      {children}
    </motion.div>
  );
}

/* Entrada (fade + subida). Por defecto al hacer scroll; con now=true anima al montar
   (útil para contenido above-the-fold como el hero, que no debe esperar al scroll). */
export function Reveal({ children, y = 30, delay = 0, className, style, as = 'div', now = false }) {
  if (NOANIM) {
    const P = as;
    return <P className={className} style={style}>{children}</P>;
  }
  const M = motion[as];
  const anim = now
    ? { animate: { opacity: 1, y: 0 } }
    : { whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: '-80px' } };
  return (
    <M
      className={className}
      style={style}
      initial={{ opacity: 0, y }}
      {...anim}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </M>
  );
}

/* Doodle decorativo posicionado en absoluto que flota (para fondos de sección) */
export function DecoDoodle({ name, size = 70, top, left, right, bottom, amp = 8, dur = 5, delay = 0, rotate, color, opacity = 0.5, draw = true }) {
  return (
    <Float amp={amp} dur={dur} delay={delay} className="deco" style={{ top, left, right, bottom, opacity }}>
      <Doodle name={name} size={size} draw={draw} color={color} rotate={rotate} />
    </Float>
  );
}

/* Estallido de sprinkles (feedback al añadir al carrito) */
export function SprinkleBurst({ show }) {
  const bits = [
    { x: -34, y: -28, r: -30, c: 'var(--mint)' },
    { x: 30, y: -34, r: 25, c: 'var(--peach)' },
    { x: -40, y: 6, r: 60, c: 'var(--rose)' },
    { x: 38, y: 4, r: -45, c: 'var(--butter)' },
    { x: -14, y: -40, r: 10, c: 'var(--rose)' },
    { x: 16, y: -42, r: -15, c: 'var(--mint)' },
  ];
  if (!show) return null;
  return (
    <span className="burst" aria-hidden>
      {bits.map((b, i) => (
        <motion.span
          key={i}
          className="burst-bit"
          style={{ background: b.c }}
          initial={{ x: 0, y: 0, rotate: 0, opacity: 1, scale: 0.6 }}
          animate={{ x: b.x, y: b.y, rotate: b.r, opacity: 0, scale: 1 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        />
      ))}
    </span>
  );
}
